<template>
    <div class="preview-step">
        <h4 class="mt-3"><b>Email Preview</b></h4>
        <p class="text-muted mb-4">Preview how your scheduled email will look when sent.</p>

        <!-- Email Preview Card -->
        <div class="d-flex justify-content-center">
            <!-- Reserve space so the recipient line truncates before the SAMPLE ribbon. -->
            <EmailPreviewCard
                :report-data="reportData"
                :card-style="{ maxWidth: '880px', '--ribbon-safe-padding': '25px' }"
            />
        </div>

        <!-- Schedule Summary -->
        <ScheduleSummaryCard :report-data="reportData" />
    </div>
</template>

<script>
import EmailPreviewCard from '../EmailPreviewCard.vue';
import ScheduleSummaryCard from '../ScheduleSummaryCard.vue';

export default {
    name: 'PreviewStep',
    components: { EmailPreviewCard, ScheduleSummaryCard },
    props: {
        reportData: {
            type: Object,
            required: true,
            default: () => ({ email_settings: {} })
        }
    }
}
</script>

<style scoped>
.preview-step {
    color: #3F3F3F;
}

.preview-step ::v-deep,
.preview-step ::v-deep .text-muted,
.preview-step ::v-deep .text-danger,
.preview-step ::v-deep .text-success {
    color: #3F3F3F !important;
}
</style>
